import bespokeValidator from './bespokeValidator';
import clear from '../../common/array/clear';
import conditionValidator from './conditionValidator';
import CustomDataSourceFields from '../../../../types/report/CustomDataSourceFields';
import IngestionConfig from '../../../../types/ingestion/IngestionConfig';
import Lookup from '../../../../types/functions/Lookup';
import ReportFieldDefinition from '../../../../types/report/ReportFieldDefinition';
import typeHelper from '../../common/typeHelper';
import uniquenessValidator from './uniquenessValidator';
import Dictionary from '../../../../types/report/Dictionary';
import UserDefinedFunction from '../../../../types/report/UserDefinedFunction';
import ErrorType from '../../../../types/report/ErrorType';
import { reportType } from '../../../constants/reportType';
import Method from '../../../../types/report/Method';
import OperandDetails from '../../../../types/functions/Operand/OperandDetails';

const maxNameCharacters = 20;

const validateMetadata = (name: string): string | null => {
    if (!name.length) {
        return 'Lookup name is required';
    }

    if (name.length > maxNameCharacters) {
        return `Lookup name max characters is ${maxNameCharacters}`;;
    }

    return null
}

const validateOperand2Only = (operandDetails: OperandDetails): string => {
    if (!operandDetails.isSetUp) {
        return 'Operand(s) not set up';
    }

    return '';
};

const validateLookup = (lookup: Lookup, functions: UserDefinedFunction[], globalFunctions: UserDefinedFunction[], lookups: Lookup[], dictionaries: Dictionary[],
    dataSources: IngestionConfig[], reportFields: ReportFieldDefinition[], customDataSourceFields: CustomDataSourceFields, configType: string): void => {

    clear(lookup.errors);

    if (!lookup.name) {

        lookup.errors.push(`Lookup name is required`);
    }

    if (typeHelper.isString(lookup.name) && lookup.name.length > maxNameCharacters) {

        lookup.errors.push(`Lookup name max character count is ${maxNameCharacters}`);
    }

    if (lookup.method === Method.Lookup && configType !== reportType.accuracy && !typeHelper.isNumber(lookup.dataSource1Id)) {
        lookup.errors.push('Lookup data source From is missing');
    }

    if (lookup.method === Method.Lookup && !typeHelper.isNumber(lookup.dataSource2Id)) {

        lookup.errors.push('Lookup data source To is missing');
    }

    if (!lookup.isBespoke) {

        Array.prototype.push.apply(lookup.errors,
            conditionValidator.validate(lookup.condition, functions, globalFunctions, lookups, dictionaries, [], dataSources, reportFields, customDataSourceFields, true, null, configType, lookup.method === Method.Indexed ? validateOperand2Only : undefined));
        return;
    }

    let error = bespokeValidator.validateCondition(lookup.bespokeCondition);
    if (error) {
        lookup.errors.push(error);
    }
};

const validate = (lookups: Lookup[], functions: UserDefinedFunction[], globalFunctions: UserDefinedFunction[], dictionaries: Dictionary[], dataSources: IngestionConfig[], reportFields: ReportFieldDefinition[], customDataSourceFields: CustomDataSourceFields, configType: string): ErrorType => {

    lookups.forEach(l => validateLookup(l, functions, globalFunctions, lookups, dictionaries, dataSources, reportFields, customDataSourceFields, configType));

    uniquenessValidator.validate(lookups, l => l.name, 'Lookup', 'name');

    let lookupWithError = lookups.find(x => x.errors.length > 0);

    return {
        componentNumber: lookupWithError?.number,
        message: lookupWithError ? 'Invalid lookups(s)' : ''
    } as ErrorType
};

const lookupValidator = {
    validate,
    validateMetadata
};

export default lookupValidator;
